import { makeStyles } from '@griffel/react';
import { MEDIA_MOBILE } from '@ksb/ui';

/** Gemeinsame Seitenstile (Griffel auf den Tokens der KSB-Design-Schicht). */
export const useSeitenStile = makeStyles({
  seite: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing-md)',
  },
  kopf: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing-xs)',
  },
  einleitung: {
    margin: 0,
    color: 'var(--color-text-secondary)',
  },
  liste: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing-xs)',
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  /** Zeilenkarte: Inhalt links, Aktion rechts; auf dem Smartphone untereinander. */
  zeile: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--spacing-sm) var(--spacing-md)',
    padding: 'var(--padding-md) var(--padding-lg)',
    borderRadius: 'var(--radius-md)',
    backgroundColor: 'var(--color-surface-white)',
    [MEDIA_MOBILE]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      padding: 'var(--padding-md)',
    },
  },
  zeileInhalt: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing-2xs)',
    flexGrow: 1,
    minWidth: 0,
  },
  zeileAktion: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 'var(--spacing-xs)',
    flexShrink: 0,
    [MEDIA_MOBILE]: { justifyContent: 'flex-start' },
  },
  titel: {
    margin: 0,
  },
  gedaempft: {
    color: 'var(--color-text-secondary)',
  },
  /** Filterzeile und Formularraster der Verwaltung: Felder nebeneinander, auf dem Smartphone untereinander. */
  felder: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: 'var(--spacing-sm) var(--spacing-md)',
    alignItems: 'end',
  },
  /** Knöpfe nebeneinander, linksbündig. */
  knoepfe: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 'var(--spacing-xs)',
  },
  /** Weiße Fläche für einen Abschnitt der Verwaltung. */
  karte: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing-sm)',
    padding: 'var(--padding-lg)',
    borderRadius: 'var(--radius-md-plus)',
    backgroundColor: 'var(--color-surface-white)',
    [MEDIA_MOBILE]: { padding: 'var(--padding-md)' },
  },
  /** Kein Zeilenumbruch (z. B. „Lernpfad A“ in einer schmalen Spalte). */
  nowrap: { whiteSpace: 'nowrap' },
  /** Kurze Einträge nebeneinander, bei Platzmangel umbrechend (z. B. offene Module in einer Zelle). */
  modulliste: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 'var(--spacing-2xs) var(--spacing-sm)',
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
  /** Zwei Spalten (Hauptteil und Seitenspalte); auf schmalen Fenstern untereinander. */
  zweispaltig: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) 340px',
    gap: 'var(--spacing-sm)',
    alignItems: 'start',
    '@media (max-width: 1100px)': { gridTemplateColumns: 'minmax(0, 1fr)' },
  },
  spalte: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing-sm)',
    minWidth: 0,
  },
  /** Überschrift links, Aktion rechts in einer Karte. */
  kartenkopf: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 'var(--spacing-xs) var(--spacing-sm)',
  },
  /** Kleine Liste in einer Tabellenzelle. */
  zellenliste: {
    margin: 0,
    paddingInlineStart: '1.1em',
  },
  /** Initialen links, Name und Kennung rechts daneben. */
  person: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--spacing-xs-plus)',
    minWidth: 0,
  },
  /** Symbol vor einem kurzen Text, z. B. beim Ort. */
  mitSymbol: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'var(--spacing-2xs)',
    color: 'var(--color-text-primary)',
    '& > svg': { flexShrink: 0, color: 'var(--color-icon-tertiary)' },
  },
});
